import Image from "components/elements/image"
import PropTypes from "prop-types"
import React from "react"
import "./quote.scss"

const Quote = ({ quote, cite, headshot }) => {
  return (
    <blockquote className="section-book-highlight-v2--quote">
      {headshot?.fluid && (
        <div className="section-book-highlight-v2--quote-headshot">
          <Image
            className="section-book-highlight-v2--quote-headshot-image"
            description={headshot?.description}
            height={headshot?.height}
            image={headshot?.fluid}
            style={headshot?.style}
            title={headshot?.title}
            width={headshot?.width}
            wrap={headshot?.wrap}
          />
        </div>
      )}
      <div className="section-book-highlight-v2--quote-content">
        {quote?.childrenMarkdownRemark?.[0]?.html && (
          <div
            className="section-book-highlight-v2--quote-text"
            dangerouslySetInnerHTML={{
              __html: quote?.childrenMarkdownRemark?.[0]?.html,
            }}
          />
        )}
        {cite && (
          <figcaption className="section-book-highlight-v2--quote-cite">
            {cite}
          </figcaption>
        )}
      </div>
    </blockquote>
  )
}

Quote.propTypes = {
  quote: PropTypes.shape({
    childrenMarkdownRemark: PropTypes.arrayOf(PropTypes.shape({
      html: PropTypes.string.isRequired,
    })),
  }),
  cite: PropTypes.string,
  headshot: PropTypes.object.isRequired,
}

export default Quote